export default {"src":"/_next/static/media/forbes_logo.3ec2101c.svg","height":54,"width":200,"blurWidth":0,"blurHeight":0};